module.exports = __webpack_public_path__ + "static/media/dum-dum-logo.eb7989d0.png";